import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata";
import { UL } from '@/components/IconList';
import { Link } from "gatsby";
import { ConfettiBtn } from "@/components/ConfettiBtn";
import useGoogleSheetData from "@/components/useGoogleSheet";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { ChevronDown, Sparkle } from "lucide-react"

function Registration() {

      const { data, loading, error } = useGoogleSheetData('1i2Bw2EVK0viMttXY89PPdqjuzzazlKux8qx4aXwJvYI', 'Registration');

      const registrationSheet = data.find(sheet => sheet.id === 'Registration');
      const registrationData = registrationSheet ? registrationSheet.data : [];
      
      const groupRegistration = data.find(sheet => sheet.id === 'Group Registration');
      const groupRegistrationData = groupRegistration ? groupRegistration.data : [];

  return (
    <>
      <section>
        <div className="container px-4 md:px-6">
          <h2>Register now for 5WCWS</h2>
          <p>Please read the registration information carefully before beginning the online registration. Registration can be submitted by completing the online form linked in the button below.</p>
        </div>
      </section>

      <section>
        <div className="container px-4 md:px-6 flex flex-col gap-10">
          <div>
            <h2>Registration fees</h2>
            <p>All fees are quoted in Australian dollars (AUD) and are inclusive of 10% GST (Goods and Services Tax).</p>
            {loading && <p>Loading...</p>}
            {error && <p>Error loading data</p>}
            {registrationData.length > 0 && (
              <Table className="mb-10">
                <TableCaption>* You are eligible for the NGO rate if you are working for a Non-Governmental Organisation.</TableCaption>
                <TableHeader>
                  <TableRow>
                    <TableHead className="bg-lteal text-white font-bold capitalize">Registration types</TableHead>
                    <TableHead className="bg-lteal text-white font-bold capitalize text-center">Standard registration</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {registrationData.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell className="font-bold">{row['REGISTRATION TYPES']}</TableCell>
                    <TableCell className="text-center">{row['STANDARD'] || '-'}</TableCell>
                  </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
            <ConfettiBtn btnText="Individual registration" link="https://icmsaust.eventsair.com/5wcws---5th-conference-of-womens-shelters/registration-form" />
          </div>

          <div>
            <h2>Group Registration</h2>
            <p>Group discount of 10% for registering 5 or more delegates closes 1 June 2025.</p>
            {loading && <p>Loading...</p>}
            {error && <p>Error loading data</p>}
            {registrationData.length > 0 && (
              <Table className="mb-10">
                <TableCaption>* You are eligible for the NGO rate if you are working for a Non-Governmental Organisation.</TableCaption>
                <TableHeader>
                  <TableRow>
                    <TableHead className="bg-lteal text-white font-bold capitalize">Registration types</TableHead>
                    <TableHead className="bg-lteal text-white font-bold capitalize text-center">Standard registration</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {groupRegistrationData.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell className="font-bold">{row['REGISTRATION TYPES']}</TableCell>
                    <TableCell className="text-center">{row['STANDARD'] || '-'}</TableCell>
                  </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
            <ConfettiBtn btnText="Group registration" link="https://icmsaust.eventsair.com/5wcws---5th-conference-of-womens-shelters/group-registration-form" />
          </div>
          <div className="flex flex-col justify-start w-full overflow-hidden mt-8">
            <h3>Currency Converter</h3>
            <iframe
            title="Xe FX widget"
            src="https://www.xe.com/currencyconverter/fx-widget?amount=1&from=AUD&to=USD&link=https%3A%2F%2Fwww.xe.com&ctaName=Convert"
            className="h-[450px] md:h-[240px] w-full"
            ></iframe>
          </div>
        </div>
      </section>

      <section>
        <div className="container px-4 md:px-6">
          <h3>Full Conference entitlements include:</h3>
          <UL>
            <li>Admission to all main 5WCWS sessions.</li>
            <li>Opportunity to purchase tickets to Pre and Post workshops and Study tours.</li>
            <li>Complimentary admission to the Welcome reception.</li>
            <li>Daily Conference catering.</li>
            <li>Delegate materials.</li>
            <li>Access to the exhibition area.</li>
            <li>Opportunity to purchase tickets for the Conference dinner.</li>
          </UL>
        </div>
      </section>

      <section>
        <div className="container px-4 md:px-6">
          <h3>Pre and Post Conference workshops</h3>
          <p>These are available to delegates at an additional cost of AUD150 per person including GST.</p>
          <p>More details will be released early 2025.</p>
          {/* <ConfettiBtn btnText="See what’s on offer now" link="/workshops" /> */}
        </div>
      </section>

      <section>
        <div className="container px-4 md:px-6">
          <h3>Study tours</h3>
          <p>These are available to delegates at an additional cost of AUD150 per person including GST.</p>
          <ConfettiBtn btnText="See what’s on offer now" link="/study-tours" />
        </div>
      </section>

      <section>
        <div className="container px-4 md:px-6">
          <h3>Welcome reception</h3>
          <p>This is included for full registration delegates. Additional guest tickets can be purchased for AUD130 per person including GST.</p>
        </div>
      </section>

      <section>
        <div className="container px-4 md:px-6">
          <h3>Conference dinner</h3>
          <p>Tickets can be purchased by delegates for AUD175 per person including GST.</p>

        </div>
      </section>

      <section>
        <div className="container px-4 md:px-6 py-10">
          <h2>Registration, accommodation and visa enquiries</h2>
          <div className="p-5 bg-slate-200 rounded-lg table">
            <h4 className="mb-3">Emily Low</h4>
            <p className="mb-2"><a href="mailto:registration@fifthworldshelterconference.org">registration@fifthworldshelterconference.org</a></p>
            <p className="mb-0">(+61 3) 9682 0500</p>
          </div>
        </div>
      </section>

      <section>
          <div className="container px-4 md:px-6 flex flex-col gap-5">
            <Accordion type="single" collapsible className="collapsible-bar">
                <AccordionItem value="tnc">
                  <AccordionTrigger className="!text-start text-3xl text-dbrown font-extrabold flex flex-row gap-2">Terms and Conditions <ChevronDown strokeWidth={3} /></AccordionTrigger>
                  <AccordionContent className="!text-start">
                    <div>
                      <h3>Cancellation of registration deadline: <b className="font-bold">15 July 2025, 5pm (AEST)</b></h3>
                      <p>Cancellations must be notified in writing (email is sufficient) to the 5WCWS Conference Secretariat.</p>
                      <UL>
                        <li>Cancellations made by 15 July 2025 will result in a full refund, less AUD150 to cover administration costs.</li>
                        <li>Alternatively, your registration may be transferred to another person by 5 September 2025 without incurring any cost penalty. The Conference Secretariat must be advised in writing of any alterations or transfers of registrations.</li>
                        <li>After 15 July 2025, cancelled registrations will only be refunded in exceptional circumstances, as assessed by the Hosts on a case-by-case basis.</li>
                      </UL>
                      <p>If you provide proof of a rejected Visa application to the Conference Secretariat, this may be considered an exceptional circumstance for a full refund, less AUD150 to cover administration costs. </p>
                    </div>

                    <div>
                      <h3>Payment</h3>
                      <p>Payment of any applicable attendance fees is due 30 days after receipt of the invoice or before the start of the Conference, whichever date may fall first. Your registration will remain provisional until payment is received.</p>
                    </div>

                    <div>
                      <h3>Conference postponement</h3>
                      <p>In the event of the Conference being postponed, all registrations will automatically be transferred to the new Conference dates. All components of your registration and associated events will also be transferred. If you are unable to attend on the new dates, you may contact the Conference Secretariat to request a transfer of your registration to a colleague at no cost, or request a cancellation and refund, which will incur an AUD150 administration fee up until the registration cancellation deadline.</p>
                    </div>

                    <div>
                      <h3>Conference cancellation</h3>
                      <p>In the event of the Conference being canceled, all registrations and associated components of attendance will be canceled, and amounts refunded in full.</p>
                    </div>

                    <div>
                      <h3>Photography policy</h3>
                      <p>You acknowledge and agree that the Hosts and the Conference Organiser may be photographing and filming at the Conference and associated events for the purpose of reporting on the Conference and for use in future promotional material; and by registering to attend, you give your consent to be photographed and filmed.</p>
                    </div>

                    <div>
                      <h3>Disclaimer</h3>
                      <p>All best endeavors will be made to present the program as published on the Conference website. The Hosts and the Conference Organiser reserve the right to alter, without prior notice, any of the arrangements, timetables, plans, or other items relating to the Conference, for any cause beyond its reasonable control. The Hosts and the Conference Organiser are not liable for any loss or inconvenience caused as a result of such alteration.</p>
                      <p>In the event of unforeseen circumstances, the Hosts and the Conference Organiser do not accept responsibility for the loss of monies caused by delays. Participants are advised to take out personal travel insurance and to extend their policy to cover personal possessions. The Hosts and the Conference Organiser do not cover individuals against cancellations of bookings or theft or damage to belongings. </p>
                    </div>

                    <div>
                      <h3>Code of conduct</h3>
                      <p>The Hosts and the Conference Organiser reserve the right to remove from the Conference at any time any attendee deemed to be causing, or potentially causing, a disturbance or exhibiting disruptive or inappropriate behavior. Such removal does not constitute a right to refund of any fees paid. Please view the <Link to="/code-of-conduct">Code of Conduct</Link> which all attendees are expected to comply with.</p>
                    </div>

                    <div>
                      <h3>Privacy</h3>
                      <p>Your privacy is important to us. The collection, use, and disclosure of personal information by the Conference Organiser are covered in our <a href="https://icmsaust.com.au/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a></p>
                    </div>
                  </AccordionContent>
                </AccordionItem>
            </Accordion>

          </div>
      </section>
    </>
  )
}

export default Registration

export function Head() {
  const { title } = useSiteMetadata();
  return (
    <>
      <title>{`Registration - ${title}`}</title>
      <meta name="description" content="Register for the 5th World Conference of Women's Shelters 2025. Secure your spot and join us for this important event focused on improving women's shelters worldwide." />
      <meta name="keywords" content="5WCWS, WCWS, Women's Shelters, World Conference, 2025, registration, Conference registration, sign up, event registration" />
    </>
  )
}
